import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_sort_bottom",
  "use": "icon-icon_general_sort_bottom-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" overflow=\"visible\" id=\"icon-icon_general_sort_bottom\">\n<polygon points=\"32.7999992,26.2999992 25,34.2000008 25,10 23,10 23,34.2000008 15.1999998,26.2999992\n\t13.6999998,27.7000008 24,38 34.2999992,27.7000008 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol